module.exports = __webpack_public_path__ + "img/magento.b411310f.png";